<template>
  <div class="Menus">
    <div class="Menus_notice" style="padding: 10px">
      <van-button
        type="info"
        size="mini"
        style="width: 100%"
        @click="$router.push('UserMenus')"
        >编辑首页应用</van-button
      >
    </div>
    <div
      class="Menus_notice hiddenScroll"
      style="overflow: auto; min-height: 50px"
      v-for="(item, index) in menuData"
      :key="index"
    >
      <div class="notice_title" style="align-items: center">
        <div class="MarginR10">
          <svg
            width="17"
            height="10"
            viewBox="0 0 17 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle opacity="0.5" cx="5" cy="5" r="5" fill="#033C88" />
            <circle cx="12" cy="5" r="5" fill="#033C88" />
          </svg>
        </div>
        <div class="flexLR" style="width: 100%">
          <div>{{ item.authName }}</div>
          <div></div>
        </div>
      </div>
      <div class="flexWrap" style="overflow: auto; width: 100%">
        <div
          class="menuItemStyle"
          style="margin: 15px 0; overflow: auto"
          v-for="(chItem, index) in item.children"
          :key="index"
        >
          <div
            class="flexLR"
            v-if="chItem.children && chItem.children.length > 0"
          >
            <div
              class="menuItemStyle"
              style="margin: 15px 0; overflow: auto"
              v-for="(el, index) in chItem.children"
              :key="index"
            >
              <div @click="openMenuTemplate(el)">
                <div>
                  <img :src="`img/6.0/${el.authName}.png`" alt="" />
                </div>
                <div class="nowrap">{{ el.authName }}</div>
              </div>
            </div>
          </div>
          <div v-else @click="openMenuTemplate(chItem)">
            <div>
              <img :src="`img/6.0/${chItem.authName}.png`" alt="" />
            </div>
            <div class="nowrap">{{ chItem.authName }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetFunctionTemplate } from "@/api/index";
export default {
  name: "Menus",
  components: {},
  data() {
    return {
      upDateHomeMenu: false,
      menuData: [],
      Menulist: [
        {
          title: "进度上报",
          icon: require("../../../assets/mobileImg/进度上报.png"),
          path: "/home/menu/MenuTemplate",
        },
        {
          title: "进度上报",
          icon: require("../../../assets/mobileImg/进度上报.png"),
          path: "/home/menu/MenuTemplate",
        },
        {
          title: "进度上报",
          icon: require("../../../assets/mobileImg/进度上报.png"),
          path: "/home/menu/MenuTemplate",
        },
        {
          title: "进度上报",
          icon: require("../../../assets/mobileImg/进度上报.png"),
          path: "/home/menu/MenuTemplate",
        },
        {
          title: "进度上报",
          icon: require("../../../assets/mobileImg/进度上报.png"),
          path: "/home/menu/MenuTemplate",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {
    openMenuTemplate(item) {
      this.$router.push({
        name: "MenuTemplate",
        query: {
          type: item.fctm01,
          name: item.fctm02,
        },
      });
    },
    getTreeDate(data, idName, pidName) {
      let result = [];
      if (!Array.isArray(data)) {
        return result;
      }
      data.forEach((item) => {
        item.id = `Tree${item[idName]}`;
        item.authName = item.fctm02.trim();
        delete item.children;
      });
      let map = {};
      data.forEach((item) => {
        item["path"] = "MenuTemplate";
        map[item[idName]] = item;
      });

      data.forEach((item) => {
        let parent = map[item[pidName]];
        if (parent) {
          (parent.children || (parent.children = [])).push(item);
        } else {
          (item["icon"] = "el-icon-star-on"), result.push(item);
        }
      });
      return result;
    },
    GetFunctionTemplate() {
      GetFunctionTemplate({ params: { xid: localStorage.xid } }).then((res) => {
        this.menuData = [];
        var dataMenu = this.getTreeDate(
          res.Data.projectfunctiontemplates,
          "fctm01",
          "fctm03"
        );
        this.menuData = this.menuData.concat(dataMenu);
      });
    },
  },
  created() {
    this.GetFunctionTemplate();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.Menus {
  margin: 0 auto;
  padding: 0 40px;
  .Menus_notice {
    width: 100%;
    height: 40%;
    background: #fff;
    margin: 20px 0;
    padding: 0 40px;
    border-radius: 5px;
    .notice_title {
      padding-top: 20px;
      display: flex;
      width: 100%;
      height: 60px;
      line-height: 50px;
    }
  }
  .menuItemStyle {
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    text-align: center;
    background: #fff;
  }
}
.MarginR10 {
  margin-right: 10px;
}
</style>
